import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
import { RawDraftContentState } from "draft-js";
import React from "react";
import { useIntl } from "react-intl";

interface ProductDetailsFormProps {
  data: {
    description: string;
    descriptionJson:string;
    name: string;
    USP:string;
    care:string;
  };
  disabled?: boolean;
  errors: ProductErrorFragment[];
  // Draftail isn't controlled - it needs only initial input
  // because it's autosaving on its own.
  // Ref https://github.com/mirumee/saleor/issues/4470
  initialDescription: RawDraftContentState;
  onChange(event: any);
}

export const ProductDetailsForm: React.FC<ProductDetailsFormProps> = ({
  data,
  disabled,
  errors,
  initialDescription,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["name", "descriptionJson","USP"], errors);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          error={!!formErrors.name}
          helperText={getProductErrorMessage(formErrors.name, intl)}
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "Name",
            description: "product name"
          })}
          name="name"
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          error={!!formErrors.USP}
          helperText={getProductErrorMessage(formErrors.USP, intl)}
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "USP",
            description: "product USP"
          })}
          name="USP"
          value={data.USP}
          onChange={onChange}
          multiline
        />
        <FormSpacer />
        <TextField
          error={!!formErrors.descriptionJson}
          helperText={getProductErrorMessage(formErrors.descriptionJson, intl)}
          disabled={disabled}
          fullWidth
          label={intl.formatMessage(commonMessages.description)?
            intl.formatMessage(commonMessages.description):
            initialDescription}
          name="description"
          value={data.description}
          onChange={onChange}
          multiline
        />
        <FormSpacer />
        <TextField
          error={!!formErrors.descriptionJson}
          helperText={getProductErrorMessage(formErrors.descriptionJson, intl)}
          disabled={disabled}
          fullWidth
          label={intl.formatMessage(commonMessages.descriptionJson)?
            intl.formatMessage(commonMessages.descriptionJson):
            initialDescription}
          name="descriptionJson"
          value={data.descriptionJson}
          onChange={onChange}
          multiline
        />
        <FormSpacer />
       

      </CardContent>
    </Card>
  );
};
export default ProductDetailsForm;
